import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js';


// Connects to data-controller="consentimientos"
export default class extends Controller {
  static targets = ['consentimiento', 'registro'];

  onClickOpenModal() {
    if (this.consentimientoTarget.value == 'HC - Antecedentes Personales') {
      get('/consentimientos_antecedentes', {
        responseKind: 'turbo-stream',
        query: {
          Registro: this.registroTarget.value
        }
      })
    } else if (this.consentimientoTarget.value == 'CGI I - Tratados por Médicos Propios') {
      get('/consentimientos_cgi', {
        responseKind: 'turbo-stream',
        query: {
          Registro: this.registroTarget.value
        }
      })
    } else if (this.consentimientoTarget.value == 'OyT I - Artroscopia') {
      get('/consentimientos_artroscopia', {
        responseKind: 'turbo-stream',
        query: {
          Registro: this.registroTarget.value
        }
      })
    }
  }
}
